$('document').ready(function () {
	// Page Loader
	$('.page-loader').fadeOut();

	$(".mobile-menu-button").click(function () {
		$(".mobile-menu").slideToggle();
		$(this).toggleClass("active");
	});

	/*function rearrangeMegaMenu() {
		// If .menu-col exists, don't run the code again
		if ($('.header .navbar-burgerless > li.menu-item-54 > .nav-dropdown > .sub-menu .menu-col').length === 0) {

			// Make sure parent id is 54 which is solutions
			$('.header .navbar-burgerless > li.menu-item-54 > .nav-dropdown > .sub-menu')
				.children('li').eq(3).insertBefore($('.header .navbar-burgerless > li.menu-item-54 > .nav-dropdown > .sub-menu > li').eq(2));

			$('.header .navbar-burgerless > li.menu-item-54 > .nav-dropdown > .sub-menu')
				.children('li').slice(0, 3).wrapAll('<li class="menu-col"></li>');

			$('.header .navbar-burgerless > li.menu-item-54 > .nav-dropdown > .sub-menu')
				.children('li').eq(1).wrap('<li class="menu-col"></li>');

			$('.header .navbar-burgerless > li.menu-item-54 > .nav-dropdown > .sub-menu')
				.children('li').eq(2).wrap('<li class="menu-col"></li>');
		}
	}

	rearrangeMegaMenu();

	$(window).resize(function () {
		rearrangeMegaMenu();
	});

	*/

	// Hide all content blocks except the first one
	$('.tab-content-wrapper > div').hide();
	$('.tab-content-wrapper > div.active').show();

	// Handle click event on navigation items
	$('.tab-nav-wrapper p').click(function () {
		var lat = $(this).data('lat');
		var long = $(this).data('long');
		// Hide all content blocks
		$('.tab-content-wrapper > div').hide();
		// Show the clicked content block
		$('.tab-content-wrapper > div').eq($(this).parent().index()).show();

		// Remove the active class from all navigation items
		$('.tab-nav-wrapper .loc').removeClass('active');
		// Add the active class to the clicked navigation item
		$(this).parent().addClass('active');
	});

	// Hamburger
	$('.hamburger').click(function () {
		$('.nav').addClass('show');
		$(this).attr('aria-expanded', 'false');
	});
	$('.close-nav').click(function () {
		$('.nav').removeClass('show');
		$(this).attr('aria-expanded', 'true');
	});

	// Close nav
	$('html').on('click', '.close-nav, .fade-overlay', function (event) {
		event.preventDefault();
		$('body').removeClass('nav-active');
		$('.fade-overlay').fadeOut(1000);
	});

	// Hover functionality for screens larger than lg

	$('#menu-main-menu > .menu-item-has-children').hover(
		function () {
			if ($(window).width() >= 992) { // Check if the screen width is larger than Bootstrap's lg breakpoint
				var $dropdown = $(this).find('.nav-dropdown').first();
				$('.header-text').hide();
				$dropdown.show();
				$('.header').addClass('active');
			}
		},
		function () {
			if ($(window).width() >= 992) { // Check if the screen width is larger than Bootstrap's lg breakpoint
				var $dropdown = $(this).find('.nav-dropdown').first();
				$('.header-text').show();
				$dropdown.hide();
				$('.header').removeClass('active');
			}
		}
	);

	// Click functionality for screens larger than lg
	$('.navbar-burgerless .menu-item-has-children .menu-item-has-children > a').click(function (event) {

		if ($(window).width() < 992) {
			event.preventDefault(); // Disable the default click action

			// Toggle the 'active-submenu' class on the clicked element
			var $menuItem = $(this).closest('.menu-item-has-children');
			var isActive = $menuItem.hasClass('active-submenu');

			// Remove 'active-submenu' class from all other .menu-item-has-children elements
			$('.navbar-burgerless .menu-item-has-children').removeClass('active-submenu');

			if (!isActive) {
				// Add 'active-submenu' class to the clicked element
				$menuItem.addClass('active-submenu');

				var $dropdown = $('.navbar-burgerless > li.current-menu-item > .nav-dropdown');
				$dropdown.show();

			} else {

				// Hide the dropdown
				$menuItem.find('.nav-dropdown').first().hide();

			}
		}
	});

	// Mobile nav top level dropdown
	$('.mobile-menu .menu-main-menu-container>ul.navbar-burgerless>li.menu-item-has-children a').click(function (event) {

		if ($(window).width() < 992) {

			if ($(this).parent().parent().hasClass('sub-menu')) {
				// Do nothing if sub item
			} else {
				event.preventDefault();
				if ($(this).parent().hasClass('active-menu')) {
					$('.mobile-menu li').removeClass('active-menu');
				} else {
					$('.mobile-menu li').removeClass('active-menu');
					$(this).parent().addClass('active-menu');

				}
			}
		}
	});

	$(".accordion__title").on("click", function (e) {

		e.preventDefault();
		var $this = $(this);

		if (!$this.hasClass("accordion-active")) {
			$(".accordion__content").slideUp(400);
			$(".accordion__title").removeClass("accordion-active");
		}

		$this.toggleClass("accordion-active");
		$this.next().slideToggle();
	});

	jQuery('.wpcf7-select').each(function () {
		var $this = jQuery(this);
		// Destroy Select2 if already initialized
		if ($this.hasClass("select2-hidden-accessible")) {
			$this.select2('destroy');
		}
		// Initialize Select2
		$this.select2();
	});

	// form-panel anchor
	$('a[href="#form-panel"]').on('click', function (e) {
		e.preventDefault();

		var headerHeight = $('.header').outerHeight();
		var targetElement = $('.form-panel');

		$('html, body').animate({
			scrollTop: targetElement.offset().top - headerHeight
		}, 1600); // Duration in milliseconds (1000 ms = 1 second)
	});

	// Any anchor
	$('a[href^="#"]').on('click', function (e) {
		e.preventDefault();

		// Get the href attribute value
		var href = $(this).attr('href');

		// Check if href starts with '#'
		if (href.startsWith('#')) {
			// Extract the class name from href (remove the leading '#')
			var className = href.slice(1);

			// Get the target element by class name
			var targetElement = $('.' + className);

			// If target element found, animate scroll
			if (targetElement.length > 0) {
				var headerHeight = $('.header').outerHeight();

				$('html, body').animate({
					scrollTop: targetElement.offset().top - headerHeight
				}, 1600); // Duration in milliseconds (1000 ms = 1 second)
			}
		}
	});

});

/*
window.onload = function () {
	gsap.registerPlugin(ScrollTrigger);

	// Target all children inside the .main container
	const flexpanels = gsap.utils.toArray('.main > .animate-stacked');
	const headerHeight = document.querySelector('.header').offsetHeight;

	flexpanels.forEach((child) => {
		gsap.fromTo(child,
			{
				opacity: 0,        // Start fully transparent
			},
			{
				opacity: 1,        // End fully visible
				duration: 2,       // Animation duration
				ease: "power2.out",
				scrollTrigger: {
					trigger: child,
					start: "top 80%",   // When the top of the element hits 80% of the viewport
					end: "bottom 60%",  // When the bottom of the element hits 60% of the viewport
					scrub: false,       // No scrubbing (no need for progress-based scroll)
					toggleActions: "play none none none", // Play the animation only once
					//markers: true       // Markers for debugging, remove in production
				}
			}
		);
	});

};
*/

// Define panels once
/*
const panels = document.querySelectorAll('.animate-stacked');

// Function to handle fixed-curve logic
function handleFixedCurve() {
	const headerHeight = document.querySelector('.header').offsetHeight;
	const viewportTop = window.scrollY;

	panels.forEach(panel => {
		const panelRect = panel.getBoundingClientRect();
		const panelBottom = panelRect.bottom + window.scrollY; // Get the bottom position of the panel relative to the viewport
		const panelBottomCurve = panel.querySelector('.bottom-curve');
		const fixedBottomCurve = panel.querySelector('.bottom-curve-fixed');
		const bottomCurveHeight = panelBottomCurve.getBoundingClientRect().height;

		if ((panelBottom - bottomCurveHeight - headerHeight) <= viewportTop) {
			// Remove fixed-curve from all elements when not active
			panels.forEach(element => {
				element.classList.remove('fixed-curve');
			});

			// Add fixed-curve when the bottom of the panel hits the top of the viewport
			panel.classList.add('fixed-curve');
			fixedBottomCurve.style.top = `${headerHeight}px`;
		} else {
			panel.classList.remove('fixed-curve');
			fixedBottomCurve.style.top = `0px`;
		}
	});
}

document.addEventListener("DOMContentLoaded", function () {
	// Clone and modify elements inside the panels on DOMContentLoaded
	panels.forEach(panel => {
		const panelBottomCurve = panel.querySelector('.bottom-curve');
		const clonedPanel = panelBottomCurve.cloneNode(true);
		clonedPanel.classList.add('bottom-curve-fixed');
		panelBottomCurve.parentNode.insertBefore(clonedPanel, panelBottomCurve.nextSibling);
	});

	// Call the function initially on page load
	handleFixedCurve();

	// Add the scroll event listener to call the same function on scroll
	window.addEventListener('scroll', handleFixedCurve);
});
*/

// Define panels once
const panels = document.querySelectorAll('.animate-stacked');

// Function to handle fixed-curve logic
function handleFixedCurve() {
	const headerHeight = document.querySelector('.header').offsetHeight;
	const viewportTop = window.scrollY;
	const viewportHeight = window.innerHeight; // Get the viewport height

	panels.forEach((panel, index) => {
		const panelRect = panel.getBoundingClientRect();
		const panelBottom = panelRect.bottom + window.scrollY; // Get the bottom position of the panel relative to the viewport
		const panelBottomCurve = panel.querySelector('.bottom-curve');
		const fixedBottomCurve = panel.querySelector('.bottom-curve-fixed');
		const bottomCurveHeight = panelBottomCurve.getBoundingClientRect().height - 3;

		// Handle normal panels
		if ((panelBottom - bottomCurveHeight - headerHeight) <= viewportTop) {
			// Remove fixed-curve from all elements when not active
			panels.forEach(element => {
				//element.classList.remove('fixed-curve');
			});

			// Add fixed-curve when the bottom of the panel hits the top of the viewport
			panel.classList.add('fixed-curve');
			fixedBottomCurve.style.top = `${headerHeight}px`;

			// Handle the previous panel's fixedBottomCurve movement
			if (index > 0) {
				const prevPanel = panels[index - 1];
				const prevFixedBottomCurve = prevPanel.querySelector('.bottom-curve-fixed');
				const prevPanelHeight = prevPanel.getBoundingClientRect().height;
				const scrollDistance = viewportTop - (panelBottom - bottomCurveHeight - headerHeight);

				// Calculate the new top position based on scroll distance
				let newTop = headerHeight - Math.min(scrollDistance, prevPanelHeight);

				prevFixedBottomCurve.style.top = `${newTop}px`;
			}
		} else {
			// If scrolling back, restore the top to 0px and remove the fixed-curve class
			panel.classList.remove('fixed-curve');
			fixedBottomCurve.style.top = `0px`;

			// Restore the previous panel's top to full height when scrolling back up
			if (index > 0) {
				const prevPanel = panels[index - 1];
				const prevFixedBottomCurve = prevPanel.querySelector('.bottom-curve-fixed');
				prevFixedBottomCurve.style.top = `${headerHeight}px`;
			}
		}

		// Special case for the last panel
		if (index === panels.length - 1) {
			// Get the bottom of the last panel relative to the viewport
			const lastPanelBottom = panelBottom;
			const scrollDistanceFromLast = viewportTop + viewportHeight - lastPanelBottom;

			// Only apply logic if the last panel is scrolled into view and beyond its bottom
			if (scrollDistanceFromLast >= 0) {
				// Handle the last panel's top animation as if there's another panel below
				const lastFixedBottomCurve = panel.querySelector('.bottom-curve-fixed');
				const lastPanelHeight = panelRect.height;

				// Calculate the new top position for the last panel's fixed bottom curve
				let lastNewTop = headerHeight - Math.min(scrollDistanceFromLast, lastPanelHeight);

				lastFixedBottomCurve.style.top = `${lastNewTop}px`;
			}
		}
	});
}

document.addEventListener("DOMContentLoaded", function () {
	// Clone and modify elements inside the panels on DOMContentLoaded
	panels.forEach(panel => {
		const panelBottomCurve = panel.querySelector('.bottom-curve');
		const clonedPanel = panelBottomCurve.cloneNode(true);
		clonedPanel.classList.add('bottom-curve-fixed');
		panelBottomCurve.parentNode.insertBefore(clonedPanel, panelBottomCurve.nextSibling);
	});

	// Call the function initially on page load
	handleFixedCurve();

	// Add the scroll event listener to call the same function on scroll
	window.addEventListener('scroll', handleFixedCurve);
});

document.addEventListener("DOMContentLoaded", function () {
	const searchField = document.querySelector('.search-field');
	const updatePlaceholder = () => {
		if (window.innerWidth >= 768) {
			searchField.setAttribute('placeholder', searchField.getAttribute('data-placeholder-large'));
		} else {
			searchField.setAttribute('placeholder', searchField.getAttribute('data-placeholder-small'));
		}
	};

	// Initial check
	updatePlaceholder();

	// Update on window resize
	window.addEventListener('resize', updatePlaceholder);
});



